// extracted by mini-css-extract-plugin
export default {"loginModal":"loginModal-Kryl9","customModal":"customModal-3AsGn"};